import { ABTestInputCondition } from './abtestV2'
// import { PDP_DISCOUNT_INCENTIVE_CAMPAIGN } from './contexts/abtestContextPdpDiscountIncentive'
import { PDP_SOCIAL_PROOF_EXPERIMENT_CAMPAIGN } from './contexts/abtestContextSocialProof'

export const activeCampaigns: ABTestInputCondition[] = [
  // PDP_DISCOUNT_INCENTIVE_CAMPAIGN,
  PDP_SOCIAL_PROOF_EXPERIMENT_CAMPAIGN,
]

